import { handleOpenChat } from "utils/analytics";

export default function Wpp() {
  return (
    <div className="absolute bottom-12 z-10 w-full px-2 overflow-hidden">
      <div className="flex flex-col items-center">
        <p className="text-white text-xl md:text-3xl text-center bg-indigo-700 px-4 py-2 rounded-xl p1">
          RESERVE SEU PASSEIO AGORA
        </p>
        <p className="text-white text-xl md:text-3xl text-center bg-indigo-800 px-4 py-2 rounded-xl mt-4 p2"> 
          E GARANTA O MENOR PREÇO
        </p>
        <button className="mt-4 bg-indigo-900 rounded-lg flex items-center px-4 py-1 a1" type="button" onClick={handleOpenChat}>
          <img src="/wpp.png" className="h-6 pr-2" alt="RESERVAR" />
          <p className=" text-white text-xl md:text-3xl">
            RESERVAR
          </p>
        </button>
      </div>
    </div>
  )
}